(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cf-klarna"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cf-klarna-info')) {
    customElements.define('cf-klarna-info', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          const dialog = this.querySelector('dialog');
          if (!dialog) return;
          if (event.target.closest('.cf-klarna__open')) {
            event.preventDefault();
            event.stopPropagation();
            dialog.showModal();
            return;
          }
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        this.addEventListener('close', () => this.querySelector('.cf-klarna__open')?.focus(), true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cf-predictive-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cf-predictive-search')) {
  customElements.define('cf-predictive-search', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.input = this.querySelector('input[name="q"]');
      this.panel = this.querySelector('[data-cf-panel]');
      this.status = this.querySelector('[data-cf-status]');
      this.listId = this.input.getAttribute('aria-controls');
      this.version = 0;
      this.index = -1;
      this.input.addEventListener('input', () => { if (!this.composing) this.schedule(); }, options);
      this.input.addEventListener('compositionstart', () => { this.composing = true; this.close(); }, options);
      this.input.addEventListener('compositionend', () => { this.composing = false; this.schedule(); }, options);
      this.input.addEventListener('focus', () => this.schedule(), options);
      this.input.addEventListener('keydown', (event) => this.navigate(event), options);
      this.addEventListener('focusout', () => {
        setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 0);
      }, options);
      document.addEventListener('pointerdown', (event) => { if (!this.contains(event.target)) this.close(); }, options);
      this.querySelector('form').addEventListener('submit', () => this.close(), options);
    }
    disconnectedCallback() {
      this.close();
      this.events?.abort();
      this.events = null;
    }
    close() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.version += 1;
      this.index = -1;
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.input.removeAttribute('aria-busy');
      this.status.textContent = '';
    }
    schedule() {
      this.close();
      const query = this.input.value.trim();
      if (query.length < 2) return;
      const version = this.version;
      this.timer = setTimeout(() => this.load(query, version), 200);
    }
    async load(query, version) {
      this.request = new AbortController();
      this.input.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      const url = new URL(this.dataset.endpoint, location.origin);
      url.search = new URLSearchParams({
        q: query,
        'resources[type]': 'product',
        'resources[limit]': '10',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'hide',
        'resources[options][fields]': 'title,product_type,variants.title,variants.sku,vendor',
        section_id: 'cf-predictive-results'
      }).toString();
      try {
        const response = await fetch(url, { signal: this.request.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text();
        if (version !== this.version || query !== this.input.value.trim() || !this.contains(document.activeElement)) return;
        const result = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cf-results]');
        if (!result) throw new Error('Missing search results');
        result.querySelector('[data-cf-list]').id = this.listId;
        result.querySelectorAll('[role="option"]').forEach((option, index) => { option.id = this.listId + '-' + index; });
        this.panel.replaceChildren(result);
        this.panel.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        this.status.textContent = result.querySelector('[data-cf-announcement]').textContent;
      } catch (error) {
        if (error.name !== 'AbortError' && version === this.version) {
          this.panel.hidden = true;
          this.input.setAttribute('aria-expanded', 'false');
          this.status.textContent = this.dataset.error;
        }
      } finally {
        if (version === this.version) this.input.removeAttribute('aria-busy');
      }
    }
    navigate(event) {
      if (event.isComposing) return;
      if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
      const options = Array.from(this.panel.querySelectorAll('[role="option"]'));
      if (this.panel.hidden || !options.length) return;
      if (event.key === 'Enter' && this.index >= 0) {
        event.preventDefault();
        options[this.index].querySelector('a').click();
        this.close();
        return;
      }
      if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
      event.preventDefault();
      this.index = event.key === 'ArrowDown' ? (this.index + 1) % options.length : (this.index <= 0 ? options.length - 1 : this.index - 1);
      options.forEach((option, index) => option.setAttribute('aria-selected', String(index === this.index)));
      this.input.setAttribute('aria-activedescendant', options[this.index].id);
      options[this.index].scrollIntoView({ block: 'nearest' });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cf-sidebar-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', (event) => {
  if (!event.target.matches('[data-cf-category-search]')) return;
  const root = event.target.closest('[data-cf-side-menu]');
  const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const query = normalize(event.target.value.trim());
  const details = [...root.querySelectorAll('details')];
  if (query && !root.dataset.filtering) {
    details.forEach(node => node.dataset.wasOpen = String(node.open));
    root.dataset.filtering = 'true';
  }
  root.querySelectorAll('[data-cf-menu-item]').forEach(item => {
    item.hidden = query !== '' && !normalize(item.textContent).includes(query);
  });
  if (query) details.forEach(node => { node.open = !node.closest('[data-cf-menu-item]').hidden; });
  else if (root.dataset.filtering) {
    details.forEach(node => { node.open = node.dataset.wasOpen === 'true'; delete node.dataset.wasOpen; });
    delete root.dataset.filtering;
  }
  const visible = [...root.querySelectorAll('[data-cf-menu-item]')].some(item => !item.hidden);
  root.querySelector('[data-cf-menu-empty]').hidden = visible;
});
document.addEventListener('click', (event) => {
  const openButton = event.target.closest('[data-cf-open-categories]');
  if (openButton) {
    const dialog = document.getElementById(openButton.getAttribute('aria-controls'));
    if (dialog && !dialog.open) { dialog.showModal(); openButton.setAttribute('aria-expanded', 'true'); }
  }
  const closeButton = event.target.closest('[data-cf-close-categories]');
  if (closeButton) closeButton.closest('dialog').close();
  if (event.target.matches('.cf-category-drawer')) {
    const rect = event.target.getBoundingClientRect();
    if (event.clientX > rect.right || event.clientY > rect.bottom) event.target.close();
  }
});
document.addEventListener('close', (event) => {
  if (!event.target.matches('.cf-category-drawer')) return;
  document.querySelectorAll('[data-cf-open-categories]').forEach(button => {
    if (button.getAttribute('aria-controls') === event.target.id) button.setAttribute('aria-expanded', 'false');
  });
}, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cf-whatsapp-chat"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cf-whatsapp-chat')) {
  customElements.define('cf-whatsapp-chat', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const details = this.querySelector('details');
      const close = () => { details.open = false; this.querySelector('summary').focus(); };
      this.querySelector('[data-close]').addEventListener('click', close);
      this.addEventListener('keydown', (event) => { if (event.key === 'Escape' && details.open) close(); });
      const field = this.querySelector('textarea');
      field.addEventListener('input', () => field.setCustomValidity(''));
      this.querySelector('form').addEventListener('submit', (event) => {
        if (!field.value.trim()) {
          event.preventDefault();
          field.value = '';
          field.reportValidity();
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
